import { stores } from '@kurtosys/app-start';
import { requests } from '@kurtosys/ksys-api-client';
import { IManifest } from '@kurtosys/types/appsManager/index.js';
import { computed, makeObservable } from 'mobx';

import { TStoreContext } from '../../../models/app/TStoreContext';
import { IComponentStyles, IConfiguration } from '../../../models/index.js';
type TGetArticle = requests.wordpress.GetArticle;
type TCompleteArticle = requests.wordpress.CompleteArticle;

const KurtosysApiStoreBase = stores.KurtosysApiStore<IConfiguration, IComponentStyles>;
const GetArticle = requests.wordpress.GetArticle;
const CompleteArticle = requests.wordpress.CompleteArticle;

export class KurtosysApiStore extends KurtosysApiStoreBase {
	constructor(storeContext: TStoreContext, manifest: IManifest) {
		super(storeContext, manifest);

		makeObservable(this);
	}

	@computed
	get getArticle(): TGetArticle {
		return this.createEndpoint(GetArticle);
	}

	@computed
	get completeArticle(): TCompleteArticle {
		return this.createEndpoint(CompleteArticle);
	}
}
